<template lang="html">
  <div class="content">
    <h5 v-if="create">Tarifas para abertura</h5>
    <table style="width:100%" v-if="create">
      <tr>
        <th>Honorários</th>
        <th>Valor</th>
      </tr>
      <tr>
        <td>ABERTURA DE EMPRESA</td>
        <td>{{ calcValues.businessOpening | currency }}</td>
      </tr>
      <tr>
        <td>JUNTA COMERCIAL</td>
        <td v-if="calcValues.tradeBoard && calcValues.tradeBoard !== '0'">{{ calcValues.tradeBoard | currency }}</td>
        <td v-else>R$ 57,00 ~ R$ 351,00</td>
      </tr>
      <tr>
        <td>TAXA DO ALVARÁ</td>
        <td v-if="calcValues.license && calcValues.license !== '0'">{{ calcValues.license | currency }}</td>
        <td v-else>R$ 120,00 ~ R$ 753,00</td>
      </tr>
      <tr class="__big">
        <td>Total</td>
        <td>{{ median | currency }}</td>
      </tr>
    </table>
    <div v-if="fee">
      <h5>Baseado nas informações fornecidas, sua mensalidade será:</h5>
      {{ fee | currency }}
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'fees',
  props: ['create'],
  data () {
    return {
    }
  },
  beforeMount () {
  },
  computed: {
    ...mapGetters([
      'calcValues',
      'revenues',
      'form',
      'employees',
      'partners'
    ]),
    median () {
      let med = 0
      med += parseFloat(this.calcValues.businessOpening) + parseFloat(this.calcValues.license) + parseFloat(this.calcValues.tradeBoard)
      if (med) return med
      return 640
    },
    partnersToBeCharged () {
      let v = parseInt(this.form.partnersQtd) - parseInt(this.partners.min) || 0
      return v > 0 ? v : 0
    },
    employeesToBeCharged () {
      let v = parseInt(this.form.employeesQtd) - parseInt(this.employees.min) || 0
      return v > 0 ? v : 0
    },
    fee () {
      if (this.form.activityCode !== undefined && this.form.revenue !== undefined && this.form.partnersQtd !== undefined && this.form.employeesQtd !== undefined) {
        let value = 0
        if (this.partnersToBeCharged) value += this.partnersToBeCharged * parseInt(this.calcValues.perPartner)
        if (this.employeesToBeCharged) value += this.employeesToBeCharged * parseInt(this.calcValues.perEmployee)
        value += parseInt(this.revenues[this.form.revenue][this.activityCodeParser(this.form.activityCode)])
        return value
      }
      return undefined
    }
  },
  mounted () {},
  methods: {
    ...mapActions([
      'setFormState'
    ]),
    activityCodeParser (index) {
      let keys = [
        'mensalidade_industria',
        'mensalidade_comercio',
        'mensalidade_servico'
      ]
      return keys[index]
    }
  },
  components: {
  }
}
</script>
<style lang="scss" type="text/css" media="screen"></style>
